const TagModule = () => import('./TagModule.vue')
const TagIndex = () => import('./views/TagIndex.vue')

export const tagRoute = {
  path: '/tags',
  name: 'tag',
  component: TagModule,
  meta: {
    title: 'Tags',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'tags-index',
      component: TagIndex,
      // Permission check disabled for development
      // Uncomment when backend permissions are ready:
      // meta: {
      //   permission: 'tag.view',
      // },
      // beforeEnter: checkPermission('tag.view'),
    },
  ],
}
